<template>
  <h4 class="summary--title">
    <a v-if="isCollapsible" class="toggle-container" @click="$emit('clickedToggle')">
      <v-icon :class="{toggle: true, isCollapsed}">arrow_drop_down</v-icon>
      <v-icon v-if="icon" class="icon">{{icon}}</v-icon>
      <slot />
    </a>

    <template v-else>
      <v-icon v-if="icon" class="icon">{{icon}}</v-icon>
      <slot />
    </template>

    <span v-if="$slots.action" class="action">
      <slot name="action" />
    </span>
  </h4>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    isCollapsible: {
      type: Boolean,
      default: false,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

h4 {
  border-bottom: 1px solid $theme-color-secondary;
  font-size: 1rem;
  font-weight: $typography-weight-semibold;
  letter-spacing: 0.05rem;
  margin: 0;
  padding: 0 0 10px;
  text-transform: uppercase;
}

.icon {
  color: $theme-color-secondary;
  font-size: 1.25rem;
  font-weight: 400;
  padding: 0 6px 0 2px;
}

.action {
  float: right;
}

.toggle-container {
  color: initial;
}

.toggle {
  color: $theme-color-secondary;
  transition: 0.2s all;
  vertical-align: middle;

  &.isCollapsed {
    transform: rotate(-90deg);
  }
}

@include responsive-breakpoint(sm) {
  h4 {
    font-size: 1rem;
    letter-spacing: 0.07rem;
    margin: 0 0 0.2rem;
  }
}
</style>
